// extracted by mini-css-extract-plugin
module.exports = {"root":"IconCamera_root__26qY7"};